<template>
  <div class="read-book">
    <text-viewer :pagetext="pageContent" :isbn="selectedBookId" />
    <!-- {{pageContent}}<br>
    {{getCurrentPageStore}}<br>
    {{getBooklengthStore}} -->
    <!-- {{getBookPagesDicStore}} -->
  </div>
</template>

<script>
import { app } from '@/firebase'
import { db } from '@/firebase'
import { mapGetters } from 'vuex'
import textViewer from '@/components/textViewer'

export default {
  name: 'ReadBook',
    data (){
      return {
        activeUser: '',
        selectedBookId: '',
        selectedBook: {},
        pageIndex: 0
      }
    },
  components: {
    textViewer
  },
  computed: {
    ...mapGetters([
      'getCurrentPageStore',
      'getBooklengthStore',
      'getBookPagesStore',
      'getBookPagesDicStore'
    ]),
    pageContent() {
      return this.getBookPagesStore[this.getCurrentPageStore]
    },
    getPage() {
      if(this.selectedBook.pages) {
        return this.selectedBook.pages[this.pageIndex]
      } else {
        return
      }
    },
  },
  methods: {
    setBook() {
      this.$store.dispatch('setBookreaderPagesAction', this.selectedBookId)
    },
    setPage() {
      this.$store.dispatch('setBookreaderCurrentPage', {bookid: this.selectedBookId, user: this.activeUser})
    },
  },
  mounted() {
    this.activeUser = app.auth().currentUser.uid
    this.selectedBookId = this.$route.params.book
    // this.getBookFromFire()
    // this.getCurrentPage(this.selectedBookId, this.activeUser)
    this.setBook()
    this.setPage()

  }
}
</script>

<style scoped>
</style>
